import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  "palette": {
    "primary": {
      "main": "#9667ff",
      "contrastText": "#f5f4fb"
    },
    "secondary": {
      "main": "#00bec3",
      "contrastText": "#001011"
    },
    "success": {
      "main": "#00a267",
      "contrastText": "#010f07"
    },
    "warning": {
      "main": "#de9f00",
      "contrastText": "#1a1000"
    },
    "error": {
      "main": "#fc4f4e",
      "contrastText": "#160605"
    },
    "info": {
      "main": "#0094ce",
      "contrastText": "#000d15"
    },
    "background": {
      "default": "#0e0b24",
      "paper": "#060516"
    },
    "text": {
      "primary": "#dadcf2",
      "secondary": "#c7c9db"
    },
    "divider": "#03020c",
    "mode": "dark"
  },
  "spacing": 8,
  "shape": {
    "borderRadius": 12
  },
});

export default theme;
